function groupBy (list, keyGetter) {
  const map = new Map()

  list.forEach(item => {
    const key = keyGetter(item)
    const collection = map.get(key)

    if (!collection) {
      map.set(key, [item])
    } else {
      collection.push(item)
    }
  })

  return Array.from(map).map(group => {
    return {
      group: group[0],
      values: group[1]
    }
  })
}

export { groupBy }
